import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { NotificationsListEvents } from '../types/notifications-list-events.enum';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';
import { NotificationService } from '../../shared/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lp2-notifications-list-iframe',
  template: `
    <iframe
      #iframe
      lp2UserwaySync
      [src]="url | safeUrl"
      frameborder="0"
      width="100%"
      height="100%"
    ></iframe>
  `,
  styleUrls: ['./notifications-list-iframe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsListIframeComponent implements OnDestroy {
  @Input() public itemsPerPage = 5;

  @ViewChild('iframe') public iframe: ElementRef;

  public get url() {
    return this.oeAppService.webNotificationsListPageHost
        + `?env=${this.oeAppService.environment}`
        + `&lang=${this.oeAppPersonService.preferredLang}`
        + `&personId=${this.oeAppPersonService.id}`
        + `&itemsPerPage=${this.itemsPerPage}`;
  }

  private readDateSetSubscription: Subscription;

  public constructor(
    private readonly oeAppService: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService,
    readonly notificationService: NotificationService
  ) {
    window.addEventListener('message', this.handleEvents.bind(this));
    this.readDateSetSubscription = notificationService.readDateSet$.subscribe(this.postReadNotificationEvent.bind(this));
  }

  ngOnDestroy(): void {
    if (this.readDateSetSubscription) {
      this.readDateSetSubscription.unsubscribe();
    }
  }

  private dispatchOpenNotificationEvent(data: MessageEvent['data']) {
    window.dispatchEvent(
      new CustomEvent('notification-event', {
        detail: data,
      })
    );
  }

  private postReadNotificationEvent(notificationId: number) {
    this.iframe.nativeElement.contentWindow.postMessage({ type: NotificationsListEvents.READ_NOTIFICATION, data: notificationId  }, '*');
  }

  private handleEvents({ data, origin }: MessageEvent) {
    if (!isIFrameSameOrigin(this.oeAppService.webNotificationsListPageHost, origin)) {
      return;
    }
    switch (data.type) {
      case NotificationsListEvents.OPEN_NOTIFICATION:
        this.dispatchOpenNotificationEvent(data);
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/notifications-list/notifications-list-iframe/notifications-list-iframe.component.ts